import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ConfirmareDocumenteService {
    private httpOptions: any;
    private basePath = environment.interop.basePath;

    public fileDownloadUrl = this.basePath + environment.interop.dgaspc.confirmareDocumente.fileDownload;
    private printDocumenteUrl = this.basePath + environment.interop.dgaspc.confirmareDocumente.printDocumente;
    private printDocumenteIstoricUrl = this.basePath + environment.interop.dgaspc.confirmareDocumente.printDocumenteIstoric;
    private predareDocumenteURL = this.basePath + environment.interop.dgaspc.confirmareDocumente.predareDocumente;

    constructor(private http: HttpClient) { }

    printDocumente(data: any) {
        return this.http.post(this.printDocumenteUrl, data, { responseType: 'blob' as 'json' });
    }

    printDocumenteIstoric(id: number) {
        return this.http.get(this.printDocumenteIstoricUrl + id, { responseType: 'blob' as 'json' });
    }

    predareDocumente(payload: number[]) {
        return this.http.post(this.predareDocumenteURL, { documentIds: payload }, this.httpOptions);
    }
}
